import { Tab, Tabs } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { ReactElement } from "react";

import { ReportTab } from "../types";

interface ReportTabsProps {
  value: ReportTab;
  onChange: (tab: ReportTab) => void;
}

const tabs: Array<{ value: ReportTab; label: string; icon: ReactElement }> = [
  { value: "inventory", label: "Inventory", icon: <Inventory2OutlinedIcon /> },
  { value: "purchase", label: "Purchase", icon: <ShoppingCartOutlinedIcon /> },
  { value: "maintenance", label: "Maintenance", icon: <BuildOutlinedIcon /> },
  { value: "supplier", label: "Supplier", icon: <GroupsOutlinedIcon /> },
  { value: "vehicle", label: "Vehicle", icon: <DirectionsCarOutlinedIcon /> },
  { value: "spareReturn", label: "Spare Returns", icon: <ReplayOutlinedIcon /> },
  { value: "lowStock", label: "Low Stock", icon: <WarningAmberOutlinedIcon /> },
];

const ReportTabs = ({ value, onChange }: ReportTabsProps) => {
  return (
    <Tabs
      value={value}
      onChange={(_, nextValue) => onChange(nextValue)}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        mb: 2,
        px: 1,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        "& .MuiTab-root": { minHeight: 48, fontWeight: 800, fontSize: "0.78rem", textTransform: "none" },
      }}
    >
      {tabs.map((tab) => (
        <Tab key={tab.value} value={tab.value} label={tab.label} icon={tab.icon} iconPosition="start" />
      ))}
    </Tabs>
  );
};

export default ReportTabs;
